<template>
  <page-content-sidebar-list-link-content
    :title="title"
    :badge="badge"
    :number="number"
    :number-limit="numberLimit"
    :disabled="disabled"
    :is-loading-number="isLoadingNumber"
    :highlight-exact-active="highlightExactActive"
    :red-counter="redCounter"
    :img="img"
    :right-icon="rightIcon"
    :tabindex="disabled ? undefined : 0"
    role="button"
    @lock-sidebar="$emit('lock-sidebar', $event)"
    @click="$emit('click')"
    @keydown.enter.self="onActivate"
    @keydown.space.self.prevent="onActivate"
  >
    <template v-slot:icon>
      <slot name="icon" />
    </template>
    <template v-slot:append>
      <slot name="append" />
    </template>
    <template v-slot:menu-item-counter>
      <slot name="menu-item-counter" />
    </template>
    <template v-slot:after-link-content>
      <slot name="after-link-content" />
    </template>
  </page-content-sidebar-list-link-content>
</template>

<script setup lang="ts">
import PageContentSidebarListLinkContent from '@/components/layout/pageContent/sidebar/sidebarItem/PageContentSidebarListLinkContent.vue'
import type { PageContentSidebarLink } from '@/components/layout/pageContent/sidebar/types'

defineProps<{
  title: string
  number?: number
  numberLimit?: number
  isLoadingNumber?: boolean
  badge?: PageContentSidebarLink['badge']
  highlightExactActive?: boolean
  disabled?: boolean
  overrideActive?: boolean
  redCounter?: boolean
  img?: string
  rightIcon?: PageContentSidebarLink['rightIcon']
}>()

defineEmits<{
  'lock-sidebar': [boolean]
  click: []
}>()

const onActivate = (event: KeyboardEvent) => {
  const target = event.currentTarget as HTMLElement
  target.click()
}
</script>
